import React from 'react';
import PropTypes from 'prop-types';
import { Col, CardHeader, Row } from 'reactstrap';
import classNames from 'classnames';

const Title = ({ titleTag: TitleTag, className, breakPoint, children }) =>
  <TitleTag className={classNames({ 'mb-0': !breakPoint, [`mb-${breakPoint}-0`]: !!breakPoint }, className )}>
    {children}
  </TitleTag>

Title.propsType = {
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  children: PropTypes.node
};

Title.defaultProps = { titleTag: 'h5' };

const FalconCardHeader = ({ title, subtitle, light, titleTag, titleClass, subtitleClass, className, breakPoint, children }) => (
  <CardHeader className={classNames({ 'bg-light': light }, className)}>
    {children?
      <Row className="align-items-center">
        <Col xs={12} md={'auto'} className='text-center text-md-right'>
          <Title breakPoint={breakPoint} titleTag={titleTag} className={(titleClass&&titleClass)+' mb-3'}>
            {title}
          </Title>
          {subtitle&&<h5>{subtitle}</h5>}
        </Col>
        <Col {...{ [breakPoint ? breakPoint : 'xs']: 'auto' }} xs={12} className={`text${breakPoint ? `-${breakPoint}` : ''}-right`}>
          {children}
        </Col>
      </Row>
    :
    <>
      <Title breakPoint={breakPoint} titleTag={titleTag} className={titleClass}>
        {title}
      </Title>
      {subtitle&&<h6 className={'m-0 mt-2 '+subtitleClass}>{subtitle}</h6>}
    </>}
  </CardHeader>
)

FalconCardHeader.propTypes = {
  title: PropTypes.node.isRequired,
  light: PropTypes.bool,
  breakPoint: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'xxl']),
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  titleClass: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

FalconCardHeader.defaultProps = { light: true };

export default FalconCardHeader;